<template>
  <div v-if="showBackground" class="background"></div>
  <SceneWebgl ref="sceneWebgl" @update-loading="updateLoadingState"/>
  <SceneIntroduction v-if="showIntroduction" @end-introduction="handleIntroductionEnd"/>
  <LoadingScreen v-if="loading" :progress="progress"/>
</template>

<script>
import SceneWebgl from './components/SceneWebgl.vue';
import LoadingScreen from "@/components/LoadingScreen.vue";
import SceneIntroduction from "@/components/SceneIntroduction.vue";

export default {
  name: 'App',
  data() {
    return {
      loading: true,
      progress: 0,
      showIntroduction: false,
      showBackground: true,
    };
  },
  methods: {
    updateLoadingState({loading, progress}) {
      this.loading = loading;
      this.progress = progress;

      if (!loading) {
        this.showIntroduction = true;
        // if (window.location.href.includes("#dev")) {
        //   setTimeout(() => {
        //     this.showBackground = false;
        //   }, 500);
        // } else {
        setTimeout(() => {
          this.showBackground = false;
        }, 3000);
        // }
      }
    },
    handleIntroductionEnd() {
      this.showIntroduction = false;
      this.triggerZoomIn();
    },
    triggerZoomIn() {
      this.$refs.sceneWebgl.zoomIn();
    }

  },
  components: {
    SceneIntroduction,
    LoadingScreen,
    SceneWebgl,
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Vinci Sans";
  src: url('@/assets/fonts/VinciSans.woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Vinci Sans";
  src: url('@/assets/fonts/VinciSans-Medium.woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Vinci Sans";
  src: url('@/assets/fonts/VinciSans-Bold.woff2');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Vinci Sans Expanded";
  src: url('@/assets/fonts/VinciSansExpanded-Bold.woff2');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Vinci Sans Expanded";
  src: url('@/assets/fonts/VinciSansExpanded-Regular.woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}


html,
body {
  margin: 0;
  overflow: hidden;
  overscroll-behavior-y: none;
  font-family: "Vinci Sans", sans-serif;

  h2, h3, h4, h5, h6 {
    margin: 0;
  }
}

.popin-pagination {
  position: absolute;
  //bottom: 1.2rem;
  bottom: auto;
  left: 1.2rem;
  font-family: "Vinci Sans Expanded", sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  gap: 0.5rem;
  color: #004289;
  z-index: 10;
  width: 5rem;
  height: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  border-radius: 2rem;
  border: 1px solid rgba(0, 66, 137, 0.2);

  .separator {
    font-weight: 200;
  }
}

.swiper-container {
  position: relative;
  height: 100%;

  .arrows {
    position: absolute;
    //bottom: 1.2rem;
    right: 1.2rem;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: space-between;
    z-index: 10;

    .arrow {
      display: flex;
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
      border: 1px solid rgba(0, 66, 137, 0.2);
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: border-color 0.3s ease-out, transform 0.3s ease-in-out;
      background-image: url(@/assets/svg/arrow.svg);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 40%;

      &:hover {
        border-color: rgba(0, 66, 137, 0.7);

        //background-color: rgba(255, 255, 255, 0.7);
      }

      &.prev {
        transform: rotate(180deg);
      }

      &.swiper-button-disabled {
        //background-color: rgba(255, 255, 255, 0.7);
        cursor: default;
        opacity: 0.66;
      }
    }
  }
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  transition: opacity 0.3s ease-out;

}

.popin {
  position: absolute;
  inset: 1rem;
  max-width: 99%;

  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-out;

  &.show {
    opacity: 1;
    pointer-events: auto;
    transition: opacity 0.3s ease-out 1.5s;
  }

  @media screen and (min-width: 768px) {
    inset: unset;
    right: 1rem;
    bottom: 1rem;
    height: fit-content;
    max-height: 95vh;
  }

  .popin-container {
    display: flex;
    flex-direction: column;
    width: 25rem;
    max-width: 90%;
    //height: 100%;
    height: fit-content;
    //max-height: 45rem;
    padding: 0 1.2rem 1.6rem 1.2rem;
    border-radius: 1.2rem;
    backdrop-filter: blur(20px);
    background: rgba(255, 255, 255, 0.7);
    overflow: hidden;

    @media screen and (max-height: 768px) {
      height: 90vh;

    }

    .swiper {
      flex: 1;
      width: 100%;
      height: 100%;
      //overflow-x: hidden;
      //overflow-y: scroll;
      //border-radius: 0.75rem;

      .swiper-wrapper,
      .swiper-slide {
        height: 100%;
      }
    }

    .popin-close {
      cursor: pointer;
      // reset button styles
      appearance: none;
      padding: 0;
      margin: 0;
      font-size: 0;
      width: 1.5rem;
      height: 1.5rem;
      aspect-ratio: 1;
      border-radius: 50%;
      border: 1px solid;
      border-color: rgba(#004289, 0.2);
      // faire la crois en bleu foncé
      background-color: transparent;
      background-image: url(@/assets/svg/cross.svg);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 50%;
      transition: border-color 0.3s ease-out;
      position: absolute;
      top: 1.0rem;
      right: 1.0rem;

      &:hover {
        border-color: #004289;
      }
    }
  }
}

.popin-header, .popin-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  //height: 3rem;
  width: fit-content;
  font-family: "Vinci Sans Expanded", sans-serif;
  padding: 1.6rem 1.6rem 1.2rem;
  color: $color-primary;
  text-align: center;
  margin: 0 auto;
  gap: 0.4rem;
  flex-direction: column;
  text-align: center;


  h2 {
    font-weight: 400;
    font-size: 0.75rem;
    text-transform: uppercase;
    margin: 0;
    text-align: center;
    color: #E40520;
  }

  h3 {
    height: 2.3rem;
    font-size: 1.25rem;
    align-content: center;
  }

}

.popin-footer {
  justify-content: space-between;
  height: 3rem;
  padding: 0.8rem 0 0 0;

}

.popin-content {
  overflow: auto;
  height: 100%;
  scrollbar-width: none;
  //border-radius: 0.75rem;


}


.popin-text {
  background-color: #fff;
  color: $color-primary;
  padding: 1rem;
  border-radius: 0.75rem;
  margin-bottom: 1.2rem;

  &:last-child {
    margin-bottom: 0;
  }

  h2 {
    display: none;

  }

  h3 {
    font-weight: 700;
    margin: 0 0 0.66rem;
  }

  h4 {
    font-weight: 500;
    margin-bottom: 0.5em;

    &::before {
      color: #E40520;
      content: ". ";
    }
  }

  .mt-0 {
    margin-top: 0;
  }

  & ul ~ h3 {
    margin-top: 1em;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    margin: 0;
    padding: 0;

    li {
      list-style-position: outside;
      margin: 0;
      position: relative;
      border-radius: 0.75rem;
      padding: 0.3rem 0 0.3rem;
      //margin-left: 0.66rem;

      &::marker {
        color: $color-secondary;
      }
    }
  }

  ul.checkmark {
    list-style-type: none;
    padding-left: 0;

    li {
      margin-left: 0;
      padding: 0.7rem 1rem 0.7rem 2rem;
      background-color: $color-primary;
      color: #fff;
      list-style-position: outside;

      &::before {
        content: "";
        width: 0.7em;
        height: 0.7em;
        position: absolute;
        left: 0.7rem;
        top: 0.8rem;
        background-image: url(@/assets/svg/checkmark-white.svg);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        display: inline-block;

      }
    }
  }

  &.popin-text-dark {
    background-color: $color-primary;
    color: #fff;

    ul.checkmark {
      li {

        background-color: #fff;
        color: $color-primary;

        &::before {
          background-image: url(@/assets/svg/checkmark-blue.svg);
        }
      }
    }
  }

  a {
    font-family: "Vinci Sans Expanded", sans-serif;
    font-size: 0.85rem;
    color: $color-primary;
  }
}

.area-tooltip {
  position: absolute;
  top: 50%;
  left: 50%;
  font-family: "Vinci Sans Expanded", sans-serif;
  font-weight: bold;
  color: $color-primary;
  font-size: 14px;
  background-color: rgba(white, 0.5);
  padding: 13px 18px;
  border-radius: 100px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-out;

  &.active {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.5s ease-out;
  }

  &::after {
    content: '';
    position: absolute;
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    top: 3px;
    left: 3px;
    border-radius: 100px;
    background-color: white;
    z-index: 1;
  }

  .area-tooltip-inner {
    position: relative;
    z-index: 2;
  }
}

.area-tooltip {
  position: absolute;
  top: 50%;
  left: 50%;
  font-family: "Vinci Sans Expanded", sans-serif;
  font-weight: bold;
  color: $color-primary;
  font-size: 14px;
  background-color: rgba(white, 0.5);
  padding: 13px 18px;
  border-radius: 100px;
  opacity: 0;
  visibility: hidden;

  transition: opacity 0.2s ease-out;

  &.active {

    .intro-finished & {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.5s ease-out;
    }
  }

  &::after {
    content: '';
    position: absolute;
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    top: 3px;
    left: 3px;
    border-radius: 100px;
    background-color: white;
    z-index: 1;
  }

  .area-tooltip-inner {
    position: relative;
    z-index: 2;
  }

}
</style>
